<!-- Main Row Container -->
<div class="row">
  <!-- Button Group and Add Button -->
  <div class="d-flex mt-3">
    <!-- Button Group for View Selection -->
    <div class="flex-grow-1 bd-highlight"></div>

    <!-- Add New Serving time Button -->
    <div class="bd-highlight pr-2">
      <button class="btn btn-dark add-btn" (click)="addNewServingTime()">+ New Serving Time</button>
    </div>
  </div>
</div>

<!-- Conditional Rendering for Table View -->
<div class="row mt-4">
  <div class="w-100 pl-4 pr-4">
    <!-- Table Header -->
    <table class="table text-center">
      <thead class="table-light">
        <tr class="bg-dark">
          <th scope="col">Serving Time</th>
          <th scope="col">Start Time</th>
          <th scope="col">End Time</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>

      <!-- Table Body -->
      <tbody>
        @for (time of servingTimes; track time; let i = $index) {
          <tr class="border">
            <td>{{ time.name }}</td>
            <td>{{ time.start_time }}</td>
            <td>{{ time.end_time }}</td>
            <td>
              <!-- Edit Serving time Action -->
              <span
                (click)="$event.stopPropagation(); addNewServingTime(time)"
                class="mr-3 p-1 rounded-1 border edit-btn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M9.38251 2.59046C9.87931 2.05222 10.1277 1.7831 10.3916 1.62612C11.0285 1.24734 11.8128 1.23556 12.4603 1.59504C12.7286 1.74403 12.9846 2.00558 13.4967 2.52867C14.0088 3.05176 14.2648 3.31331 14.4106 3.58745C14.7626 4.24891 14.751 5.05002 14.3802 5.70063C14.2266 5.97027 13.9631 6.22402 13.4362 6.7315L7.16711 12.7697C6.16863 13.7314 5.66938 14.2123 5.04542 14.456C4.42145 14.6997 3.73551 14.6818 2.36361 14.6459L2.17696 14.641C1.75931 14.6301 1.55049 14.6246 1.4291 14.4868C1.30771 14.3491 1.32428 14.1364 1.35743 13.711L1.37543 13.48C1.46871 12.2825 1.51535 11.6838 1.74918 11.1456C1.983 10.6074 2.38633 10.1705 3.19299 9.2965L9.38251 2.59046Z"
                    stroke="#98A0AE"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.66663 2.6665L13.3333 7.33317"
                    stroke="#98A0AE"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.33337 14.6665H14.6667"
                    stroke="#98A0AE"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <!-- Delete Serving time Action -->
              <span
                class="border p-1 rounded-1 delete-btn"
                (click)="$event.stopPropagation(); deleteServingTimeConfirm(time)"
              >
                <svg
                  class="icon-danger"
                  width="12"
                  height="12"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="delete-02">
                    <path
                      id="Vector"
                      d="M13 3.6665L12.5869 10.3499C12.4813 12.0574 12.4285 12.9112 12.0005 13.5251C11.7889 13.8286 11.5165 14.0847 11.2005 14.2772C10.5614 14.6665 9.706 14.6665 7.99513 14.6665C6.28208 14.6665 5.42553 14.6665 4.78603 14.2764C4.46987 14.0836 4.19733 13.827 3.98579 13.523C3.55792 12.9082 3.5063 12.0532 3.40307 10.3433L3 3.6665"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      id="Vector_2"
                      d="M2 3.66683H14M10.7038 3.66683L10.2487 2.72798C9.9464 2.10434 9.7952 1.79251 9.53447 1.59804C9.47667 1.5549 9.4154 1.51652 9.35133 1.4833C9.0626 1.3335 8.71607 1.3335 8.023 1.3335C7.31253 1.3335 6.95733 1.3335 6.66379 1.48958C6.59873 1.52417 6.53665 1.5641 6.47819 1.60894C6.21443 1.8113 6.06709 2.13453 5.77241 2.781L5.36861 3.66683"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      id="Vector_3"
                      d="M6.33337 11V7"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      id="Vector_4"
                      d="M9.66663 11V7"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </g>
                </svg>
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
